import React, { useState } from 'react';
import { personAPI } from '../services/api';

const CreatePersonModal = ({ onClose, onPersonCreated }) => {
  const [formData, setFormData] = useState({
    name: '',
    nickname: '',
    username: '',
    email: '',
    phone: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) {
      setError('Name is required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await personAPI.create(formData);
      onPersonCreated(response.data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to create record');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-tech-bg/80 backdrop-blur-sm flex items-center justify-center p-4 z-50 animate-fade-in">
      <div className="tech-card p-6 max-w-md w-full">
        <div className="flex items-center justify-between mb-6">
          <div>
            <span className="tech-section-title">NEW RECORD</span>
            <h3 className="text-lg font-mono font-semibold text-tech-text mt-1">CREATE ENTRY</h3>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-tech-textMuted hover:text-tech-text hover:bg-tech-surface rounded transition"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <div className="p-3 bg-tech-danger/10 border border-tech-danger/30 rounded text-tech-danger text-sm font-mono flex items-center gap-2">
              <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>{error}</span>
            </div>
          )}

          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">
              NAME *
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="tech-input"
              placeholder="Full name"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-mono text-tech-textMuted mb-2">
                NICKNAME
              </label>
              <input
                type="text"
                name="nickname"
                value={formData.nickname}
                onChange={handleChange}
                className="tech-input"
                placeholder="Alias"
              />
            </div>
            <div>
              <label className="block text-xs font-mono text-tech-textMuted mb-2">
                USERNAME
              </label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                className="tech-input"
                placeholder="Username"
              />
            </div>
          </div>

          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">
              EMAIL
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="tech-input"
              placeholder="email@domain.com"
            />
          </div>

          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">
              PHONE
            </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="tech-input"
              placeholder="+1 234 567 890"
            />
          </div>

          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 tech-btn-secondary py-2"
            >
              CANCEL
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 tech-btn-primary py-2 disabled:opacity-50"
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                  </svg>
                  CREATING
                </span>
              ) : (
                <span>CREATE</span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreatePersonModal;
